import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { base64ToBlob } from "src/utils/blob/blobUtil";
import { getData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import { PRD3060_R01DetailDto, PRD3060_R01Dto } from "./Dto_PRD3060_R01";
import { PRD3060_R01Filter } from "./Store_PRD3060_R01";

const baseUrl = `${config.apiUrl}/PRD3060_R01`;

const getParams = (filter: Partial<PRD3060_R01Filter>) => ({
    compCd: filter.compCd,
    startDate: filter.productDt?.from ? formatDate(filter.productDt.from) : undefined,
    endDate: filter.productDt?.to ? formatDate(filter.productDt.to) : undefined,
    brandCd: filter.brandCd,
    compNm: filter.compNm,
    outputDt: filter.outputDt ? formatDate(filter.outputDt) : undefined,
});

export const getPRD3060_R01List = async (
    option: string,
    params: Partial<PRD3060_R01Filter>
) => {
    const url = `${baseUrl}/${option}`;
    return await getData<ResponseDto<PRD3060_R01Dto[]>>(url, { params: getParams(params) });
};

export const getPRD3060_R01AllCount = async (params: Partial<PRD3060_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, { params: getParams(params) });
};

export const getPRD3060_R01DetailList = async (productResultNo: string) => {
    const url = `${baseUrl}/detail/${productResultNo}`;
    return await getData<ResponseDto<PRD3060_R01DetailDto[]>>(url);
};

export const getPdfBlob_PRD3060_R01 = async (
    params: Partial<PRD3060_R01Filter>
): Promise<Blob> => {
    const response = await getData<ResponseDto<string>>(
        `${baseUrl}/print`,
        { params: getParams(params) }
    );
    return base64ToBlob(response.data.data, "application/pdf");
};
